/**
 * These phone numbers are used in all components
 * Change them here and all components will get them.
 */
export const PHONE_NUMBER = '1300003726';
export const PHONE_NUMBER_FORMATTED = '1300 003 726';
